import * as React from "react";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { NearestLocation } from "src/typings/microserviceModels/hotels-flex-module.d.ts";
import {
  sendImmediateTrackEvent,
  FlexTrackingInfo,
  Action
} from "src/components/utility/analytics/FlexAnalyticsUtils";
import { AnalyticsStore } from "bernie-core";
import { inject } from "mobx-react";

interface NearestLocationProps {
  model?: NearestLocation;
  analytics?: AnalyticsStore;
}

export enum NearestType {
  DOWNTOWN = "DOWNTOWN",
  POI = "POI"
}

const iconDictionary = {
  [NearestType.DOWNTOWN]: "place",
  [NearestType.POI]: "location_city"
};

enum NO_RESULTS_FOUND {
  DOWNTOWN = "downtown-text.empty",
  POI = "poi-text.empty"
}

const sendTrackNoResultsFound = (rfrr: string, analytics: AnalyticsStore) => {
  const flexTrackingInfo: FlexTrackingInfo = {
    moduleName: "nearestLocationContent",
    rfrr,
    action: Action.IMPRESSION
  };

  sendImmediateTrackEvent(flexTrackingInfo, analytics);
};

export const NearestLocationContent = inject("analytics")((props: NearestLocationProps) => {
  const { model, analytics } = props;

  if (!model) {
    return null;
  }

  const { type, text } = model;

  if (!text) {
    sendTrackNoResultsFound(NO_RESULTS_FOUND[type], analytics as AnalyticsStore);

    return null;
  }

  return (
    <div className="uitk-cell all-t-padding-three uitk-flex uitk-flex-gap-two">
      <UitkIcon name={iconDictionary[type]} size={UitkIconSize.SMALL} />
      <span className="uitk-type-300">{text}</span>
    </div>
  );
});
